import { render, staticRenderFns } from "./Lp2.vue?vue&type=template&id=10235050&scoped=true&"
import script from "./Lp2.vue?vue&type=script&lang=js&"
export * from "./Lp2.vue?vue&type=script&lang=js&"
import style0 from "./Lp2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Lp2.vue?vue&type=style&index=1&id=10235050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10235050",
  null
  
)

export default component.exports